<template>
  <div>
    <div class="container">
      <article class="message is-info">
        <div class="message-header large">
          <p>Update 09/03/2020 11:07PM</p>
          <!-- <button class="delete" aria-label="delete"></button> -->
        </div>
        <div class="message-body medium">
          <ul>
            <li style="color:purple"> Site - Added Faceoffs PVP - Will only work when we're the away team!</li>
          </ul>
        </div>
      </article>
    </div>
    <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
      <article class="tile is-child" style="margin:0 auto;">
        <chart :type="'horizontalBar'" :data="fo_total_chart" :options="fo_total_options" style="display:none;max-width:50%;height=400px;margin:0 auto;"></chart>
      </article>
    </div>
    <div class="is-parent is-12 is-vertical">
      <article class="is-child box">
        <div class="columns">
          <div class="column is-4">
            <p class="title has-text-centered">{{Fixture[0].match_date}}</p>
          </div>
          <div class="column is-2">
            <img class="team_logo" :src="Fixture[0].home_team.logo">
            <p class="title has-text-left	">{{Fixture[0].home_team.name}} </p>
          </div>
          <div class="column is-2">
            <img class="team_logo" :src="Fixture[0].away_team.logo">
            <p class="title has-text-left">{{Fixture[0].away_team.name}}</p>
          </div>
          <div class="column is-4">
            <p class="title has-text-centered">{{Fixture[0].competition}}</p>
            <p class="title has-text-centered">{{Fixture[0].location}}</p>
            <p v-if="Fixture[0].is_stream == 1" class="title has-text-centered">Stream</p>
            <p v-if="Fixture[0].is_stream == 0" class="title has-text-centered">Live</p>
          </div>
        </div>
      </article>
    </div>
    <div class="is-parent is-6 is-vertical">
      <article class=" is-child box">
        <div class="container">
          <p class="title has-text-centered">Game Summary</p>
          <h1 class="subtitle has-text-centered" style="margin-top:20px;"><b>Goals</b></h1>
          <table class="table is-striped">
            <thead>
              <th>Team</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>OT</th>
              <th>PP</th>
              <th>Total</th>
            </thead>
            <tbody>
              <tr>
                <td>{{Fixture[0].home_team.name}}</td>
                <td>{{Summary.home_goals_p1}}</td>
                <td>{{Summary.home_goals_p2}}</td>
                <td>{{Summary.home_goals_p3}}</td>
                <td>{{Summary.home_goals_ot}}</td>
                <td>{{Summary.home_goals_pp}} / {{Summary.situation_opts[0].PPTotal}}</td>
                <td><b>{{Summary.home_goals_total}}</b></td>
              </tr>
              <tr>
                <td>{{Fixture[0].away_team.name}}</td>
                <td>{{Summary.away_goals_p1}}</td>
                <td>{{Summary.away_goals_p2}}</td>
                <td>{{Summary.away_goals_p3}}</td>
                <td>{{Summary.away_goals_ot}}</td>
                <td>{{Summary.away_goals_pp}} /  {{Summary.situation_opts[0].SHTotal}}</td>
                <td><b>{{Summary.away_goals_total}}</b></td>
              </tr>
            </tbody>
          </table>
          <h1 class="subtitle has-text-centered"><b>Shots</b></h1>
          <h1 class="subtitle has-text-centered">All Attempts</h1>
          <table class="table is-striped">
            <thead>
              <th>Team</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>OT</th>
              <th>Total</th>
              <th>+/-</th>
            </thead>
            <tbody>
              <tr>
                <td>{{Fixture[0].home_team.name}}</td>
                <td>{{Summary.home_shots_p1}}</td>
                <td>{{Summary.home_shots_p2}}</td>
                <td>{{Summary.home_shots_p3}}</td>
                <td>{{Summary.home_shots_ot}}</td>
                <td><b>{{Summary.home_shots_total}}</b></td>
                <td>{{Summary.home_shots_total - Summary.away_shots_total}}</td>
              </tr>
              <tr>
                <td>{{Fixture[0].away_team.name}}</td>
                <td>{{Summary.away_shots_p1}}</td>
                <td>{{Summary.away_shots_p2}}</td>
                <td>{{Summary.away_shots_p3}}</td>
                <td>{{Summary.away_shots_ot}}</td>
                <td><b>{{Summary.away_shots_total}}</b></td>
              </tr>
            </tbody>
          </table>
          <h1 class="subtitle has-text-centered">On Target</h1>
          <table class="table is-striped">
            <thead>
              <th>Team</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>OT</th>
              <th>Total</th>
              <th>+/-</th>
            </thead>
            <tbody>
              <tr>
                <td>{{Fixture[0].home_team.name}}</td>
                <td>{{Summary.home_sot_p1}}</td>
                <td>{{Summary.home_sot_p2}}</td>
                <td>{{Summary.home_sot_p3}}</td>
                <td>{{Summary.home_sot_ot}}</td>
                <td><b>{{Summary.home_sot_total}}</b></td>
                <td>{{Summary.home_sot_total - Summary.away_sot_total}}</td>
              </tr>
              <tr>
                <td>{{Fixture[0].away_team.name}}</td>
                <td>{{Summary.away_sot_p1}}</td>
                <td>{{Summary.away_sot_p2}}</td>
                <td>{{Summary.away_sot_p3}}</td>
                <td>{{Summary.away_sot_ot}}</td>
                <td><b>{{Summary.away_sot_total}}</b></td>
              </tr>
            </tbody>
          </table>
          <h1 class="subtitle has-text-centered"><b>Faceoffs</b></h1>
          <table class="table is-striped">
            <thead>
              <th>Team</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>OT</th>
              <th>Total</th>
              <th>+/-</th>
            </thead>
            <tbody>
              <tr>
                <td>{{Fixture[0].home_team.name}}</td>
                <td>{{Summary.home_fo_p1}}</td>
                <td>{{Summary.home_fo_p2}}</td>
                <td>{{Summary.home_fo_p3}}</td>
                <td>{{Summary.home_fo_ot}}</td>
                <td><b>{{Summary.home_fo_total}}</b></td>
                <td>{{Summary.home_fo_total - Summary.away_fo_total}}</td>
              </tr>
              <tr>
                <td>{{Fixture[0].away_team.name}}</td>
                <td>{{Summary.away_fo_p1}}</td>
                <td>{{Summary.away_fo_p2}}</td>
                <td>{{Summary.away_fo_p3}}</td>
                <td>{{Summary.away_fo_ot}}</td>
                <td><b>{{Summary.away_fo_total}}</b></td>
              </tr>
            </tbody>
          </table>
        </div>
      </article>
    </div>
    <div class="tile is-parent is-12 is-vertical">
      <article class="tile is-child box">
        <div class="container">
          <h2 class="subtitle">Filters</h2>
          <button v-bind:class="{'is-default': this.$route.params.period == 1,  'is-primary': this.$route.params.period != 1}" class="button  is-large" @click="setPeriod(1)">Period 1</button>
          <button v-bind:class="{'is-default': this.$route.params.period == 2,  'is-primary': this.$route.params.period != 2}" class="button is-large" @click="setPeriod(2)">Period 2</button>
          <button v-bind:class="{'is-default': this.$route.params.period == 3,  'is-primary': this.$route.params.period != 3}" class="button is-large" @click="setPeriod(3)">Period 3</button>
          <button v-bind:class="{'is-default': this.$route.params.period == 4,  'is-primary': this.$route.params.period != 4}" class="button is-large" @click="setPeriod(4)">Overtime</button>
          <button v-bind:class="{'is-default': this.$route.params.period == 0,  'is-primary': this.$route.params.period != 0}" class="button is-large" @click="setPeriod(0)">Total</button>
        </div>
        <div class="container is-child" style="margin-top:5px;">
          <h2 class="subtitle">Quicklinks</h2>
          <button class="button is-large" v-scroll-to="'#Gamesheet'">Gamesheet</button>
          <button class="button is-large" v-scroll-to="'#Shots'">Shots</button>
        </div>
      </article>
    </div>
    <div class="tile is-parent is-12 is-vertical">
      <article class="tile is-child box">
        <section class="hero bold">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">Faceoffs - All Situations</h1>
            </div>
          </div>
        </section>
        <div class="tile is-parent is-12 is-vertical" style="margin:0 auto;">
          <div class="columns">
            <div class="column is-half is-offset-one-quarter">
              <h1 class="subtitle has-text-centered">Player Totals</h1>
              <chart :type="'horizontalBar'" :data="fo_player_t" :options="fo_options" style=""></chart>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <chart :type="'horizontalBar'" :data="fo_player_l" :options="fo_options" style=""></chart>
            </div>
            <div class="column">
              <chart :type="'horizontalBar'" :data="fo_player_c" :options="fo_options" style=""></chart>
            </div>
            <div class="column">
              <chart :type="'horizontalBar'" :data="fo_player_r" :options="fo_options" style=""></chart>
            </div>
          </div>
          <table class="table is-responsive is-striped is-hoverable">
            <thead>
              <th align="center" >#</th>
              <th class="testAlign is-capitalized">Left W / L</th>
              <th align="center">+/-</th>
              <th align="center">Center W / L</th>
              <th align="center">+/-</th>
              <th align="center">Right W / L</th>
              <th align="center">+/-</th>
              <th align="center">Taken</th>
              <th align="center">Total W / L</th>
              <th align="center">Total +/-</th>
              <th align="center">Total Win %</th>
            </thead>
            <tbody >
              <tr v-for="result in this.FaceoffsChart.all_situations" v-bind:key="result.player_id">
                <td>{{result.player_id}}</td>
                <td class="fo-left has-text-centered">{{result.left_win}} / {{-result.left_loss}}</td>
                <td class="fo-left has-text-centered"><b>{{result.left_win - (-result.left_loss)}}</b></td>
                <td class="fo-center has-text-centered">{{result.center_win}} / {{-result.center_loss}}</td>
                <td class="fo-center has-text-centered"><b>{{result.center_win - -result.center_loss}}</b></td>
                <td class="fo-right has-text-centered">{{result.right_win}} / {{-result.right_loss}}</td>
                <td class="fo-right has-text-centered"><b>{{result.right_win - -result.right_loss}}</b></td>
                <td class="fo-total has-text-centered">{{result.total_win + -result.total_loss}}</td>
                <td class="fo-total has-text-centered">{{result.total_win}} / {{-result.total_loss}}</td>
                <td class="fo-total has-text-centered">{{result.total_win - (-result.total_loss)}}</td>
                <td class="fo-total has-text-centered"><b>{{result.win_percentage}}</b></td>
              </tr>
            </tbody>
          </table>
          <collapse accordion>
            <collapse-item title="Situational - EH PP SH" style="font-size:18px;font-weight:normal;">
              <h1 class="title">Even Handed</h1>
              <div class="columns">
                <div class="column">
                  <chart :type="'horizontalBar'" :data="fo_player_l_eh" :options="fo_options" style=""></chart>
                </div>
                <div class="column">
                  <chart :type="'horizontalBar'" :data="fo_player_c_eh" :options="fo_options" style=""></chart>
                </div>
                <div class="column">
                  <chart :type="'horizontalBar'" :data="fo_player_r_eh" :options="fo_options" style=""></chart>
                </div>
              </div>
              <h1 class="title">Power Play</h1>
              <div class="columns">
                <div class="column">
                  <chart :type="'horizontalBar'" :data="fo_player_l_pp" :options="fo_options" style=""></chart>
                </div>
                <div class="column">
                  <chart :type="'horizontalBar'" :data="fo_player_c_pp" :options="fo_options" style=""></chart>
                </div>
                <div class="column">
                  <chart :type="'horizontalBar'" :data="fo_player_r_pp" :options="fo_options" style=""></chart>
                </div>
              </div>
              <h1 class="title">Short Handed</h1>
              <div class="columns">
                <div class="column">
                  <chart :type="'horizontalBar'" :data="fo_player_l_sh" :options="fo_options" style=""></chart>
                </div>
                <div class="column">
                  <chart :type="'horizontalBar'" :data="fo_player_c_sh" :options="fo_options" style=""></chart>
                </div>
                <div class="column">
                  <chart :type="'horizontalBar'" :data="fo_player_r_sh" :options="fo_options" style=""></chart>
                </div>
              </div>
            </collapse-item>
          </collapse>
          <FaceoffTeamVS :home_name="Fixture[0].home_team.name" :away_name="Fixture[0].away_team.name"></FaceoffTeamVS>
          
        </div>
      </article>
    </div>
          <faceoffs-pvp :opponent="Fixture[0].home_team.id" :game_id="this.$route.params.gameId"></faceoffs-pvp>

      <article id="Turnovers" class="tile is-child box">
        <section class="hero bold">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">Turnovers - All Situations</h1>
            </div>
          </div>
        </section>
        <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
          <article class="tile is-child" style="margin:0 auto;">
            <p>Even Handed</p>
            <chart :type="'bar'" :data="to_player_eh" :options="bar_options" style=""></chart>
          </article>
        </div>
        <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
          <article class="tile is-child" style="margin:0 auto;">
            <p>Power Play</p>
            <chart :type="'bar'" :data="to_player_pp" :options="bar_options" style=""></chart>
          </article>
        </div>
        <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
          <article class="tile is-child" style="margin:0 auto;">
            <p>Short Handed</p>
            <chart :type="'bar'" :data="to_player_sh" :options="bar_options" style=""></chart>
          </article>
        </div>
      </article>
      <shots-heatmap :home_name="Fixture[0].home_team.name" :away_name="Fixture[0].away_team.name"></shots-heatmap>
            <div class="tile is-parent is-8 is-vertical" style="margin:0 auto;">
              <article class="tile is-child" style="margin:0 auto;">
                <h1 class="title">Shots On Target</h1>
                <div class="columns">
                  <div class="column is-4">
                    <div class="control">
                      <div class="select">
                        <select  v-model="selectedSOTSort">
                          <option v-for="option in sotOptions" v-bind:value="option.value" v-bind:key="option.value" >
                            {{option.text}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <chart :type="'bar'" :data="sot_totals" :options="sot_bar_options" style=""></chart>
              </article>
            </div>
            <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
              <article class="tile is-child" style="margin:0 auto;">
                <h1 class="title">+/-</h1>
              </article>
            </div>
            <div class="tile is-parent is-8 is-vertical" style="margin:0 auto;">
              <article class="tile is-child" style="margin:0 auto;">
                <article class="is-child">
                  <h1 class="subtitle">Filters</h1>
                  <div class="columns">
                    <div class="column is-4">
                      <div class="control">
                        <div class="select">
                          <select  v-model="selectedPlusMinusSort">
                            <option v-for="option in plusMinusOptions" v-bind:value="option.value" v-bind:key="option.value" >
                              {{option.text}}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
                <chart :type="'horizontalBar'" :data="plus_minus_auto_totals" :options="shots_horz_bar_options" style=""></chart>
                <chart :type="'horizontalBar'" :data="plus_minus_auto_diff" :options="shots_horz_bar_options" style=""></chart>
                <div class="title is-parent is-6 is-vertical" style="margin:0 auto;">
                  <div class="block content">
                    <table class="table is-responsive is-striped is-hoverable">
                      <thead>
                        <th>Player</th>
                        <th>CF</th>
                        <th>CA</th>
                        <th>DIFF</th>
                        <th>CF%</th>
                      </thead>
                      <tbody>
                        <tr v-for="player in sortByPlusMinusHomeAuto" v-bind:key="player.player_id">
                          <td>{{player.player_id}}</td>
                          <td>{{player.shots_for}}</td>
                          <td>{{-player.shots_against}}</td>
                          <td>{{player.diff}}</td>
                          <td>{{player.percentage}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                </article>
            </div>
          </article>

      <shot-diff-time :home_name="Fixture[0].home_team.name" :away_name="Fixture[0].away_team.name"></shot-diff-time>
      <shot-quality :game_id="this.$route.params.gameId" :home_name="Fixture[0].home_team.name" :away_name="Fixture[0].away_team.name"></shot-quality>

      <article  v-if="Fixture[0].is_stream == 0" id="OddmanRushes" class="tile is-child box">
        <section class="hero bold">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">Oddman Rushes - All Situations</h1>
            </div>
          </div>
        </section>
        <div class="is-parent" style="margin:0 auto;">
            <article class="is-child" style="margin:0 150px;">
              
            </article>
        </div>
        <div class="title is-parent is-6 is-vertical" style="margin:0 auto;">
          <div class="block content">
            <table class="table is-responsive is-striped is-hoverable">
              <thead>
                <th>{{Fixture[0].home_team.name}}</th>
                <th>{{Fixture[0].away_team.name}}</th>
              </thead>
              <tbody>
                <tr>
                  <td>{{OddmanRushes.home_rushes}}</td>
                  <td>{{OddmanRushes.away_rushes}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </article>
      <article   id="Hits" class="tile is-child box">
        <section class="hero bold">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">Hits</h1>
            </div>
          </div>
        </section>
        <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
          <article class="tile is-child" style="margin:0 auto;">
            <div class="columns">
                  <div class="column is-4">
                    <div class="control">
                      <div class="select">
                        <select  v-model="selectedHitSort">
                          <option v-for="option in sotOptions" v-bind:value="option.value" v-bind:key="option.value" >
                            {{option.text}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
            <chart :type="'bar'" :data="hit_player_totals" :options="bar_options" style=""></chart>
          </article>
        </div>
      </article>
      <article id="Gamesheet" class="tile is-child box">
        <section class="hero bold">
          <div class="hero-body">
            <div class="container">
              <h1 class="title">Gamesheet</h1>
              <p>Goal +/- is Even Handed </p>
              <p>Shot +/- SOT FOT is All Situations</p>
              <p>FO - Faceoff Wins / Faceoffs Taken</p>
            </div>
          </div>
        </section>
        <div  v-if="Fixture[0].is_stream == 0" class="title is-parent is-6 is-vertical" style="margin:0 auto;">
          <div class="block content">
            <h2 class="subtitle has-text-centered">Forwards</h2>
            <table class="table is-responsive is-striped is-hoverable">
              <thead>
                <th  class="has-text-centered" title="Player Number">#</th>
                <th  class="has-text-centered" title="TOI goals for even handed">+</th>
                <th  class="has-text-centered" title="TOI goals against even handed">-</th>
                <th  class="has-text-centered" title="TOI goals +/- even handed">+/-</th>
                <th  class="has-text-centered" title="Faceoffs won / Faceoffs taken all situations">FO</th>
                <th  class="has-text-centered" title="TOI chances for even handed">Shots For</th>
                <th  class="has-text-centered" title="TOI chances against even handed">Shots Against</th>
                <th  class="has-text-centered" title="TOI chances +/- even handed">Shots Diff</th>
                <th  class="has-text-centered" title="Shots on target all situations">SOT</th>
                <th  class="has-text-centered" title="TOI shifts all situations">Shifts</th>
                <th  class="has-text-centered" title="TOI average shift time all situations">AvgShifts</th>
                <th  class="has-text-centered" title="TOI 5v5 time even handed">EH</th>
                <th  class="has-text-centered" title="TOI power play time"><span v-if="Fixture[0].away_team.name === 'Cardiff Devils'">SH </span> <span v-else>PP</span></th>
                <th  class="has-text-centered" title="TOI short handed time"><span v-if="Fixture[0].away_team.name === 'Cardiff Devils'">PP </span> <span v-else>SH</span></th>
                <th  class="has-text-centered" title="Total time on ice all situations">Total TOI</th>
              </thead>
              <tbody >
                <tr v-for="result in sortBytimeForwards" v-bind:key="result.number">
                  <td class="tbl-name has-text-centered">{{result.number}}</td>
                  <td class="tbl-goal has-text-centered">{{result.goals_for}}</td>
                  <td class="tbl-goal has-text-centered">{{result.goals_against}}</td>
                  <td class="tbl-goal has-text-centered">{{result.goal_diff}}</td>
                  <td class="has-text-centered" >{{result.fo}}</td>
                  <td class="tbl-shots has-text-centered">{{result.shots_for}}</td>
                  <td class="tbl-shots has-text-centered">{{result.shots_against}}</td>
                  <td class="tbl-shots has-text-centered">{{result.shots_plus_minus}}</td>
                  <td class="has-text-centered" >{{result.sot}}</td>
                  <td class="has-text-centered" >{{result.shifts}}</td>
                  <td class="has-text-centered" >{{result.avg_shift}}</td>
                  <td class="has-text-centered" >{{result.eh_time}}</td>
                  <td class="has-text-centered" >{{result.pp_time}}</td>
                  <td class="has-text-centered" >{{result.sh_time}}</td>
                  <td class="has-text-centered" ><b>{{result.total_toi}}</b></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div  v-if="Fixture[0].is_stream == 0" class="title is-parent is-6 is-vertical" style="margin:0 auto;">
          <div class="block content">
            <h2 class="subtitle has-text-centered">Defense</h2>
            <table class="table is-responsive is-striped is-hoverable">
              <thead>
                <th  class="has-text-centered" title="Player Number">#</th>
                <th  class="has-text-centered" title="TOI goals for even handed">+</th>
                <th  class="has-text-centered" title="TOI goals against even handed">-</th>
                <th  class="has-text-centered" title="TOI goals +/- even handed">+/-</th>
                <th  class="has-text-centered" title="Faceoffs won / Faceoffs taken all situations">FO</th>
                <th  class="has-text-centered" title="TOI chances for even handed">Shots For</th>
                <th  class="has-text-centered" title="TOI chances against even handed">Shots Against</th>
                <th  class="has-text-centered" title="TOI chances +/- even handed">Shots Diff</th>
                <th  class="has-text-centered" title="Shots on target all situations">SOT</th>
                <th  class="has-text-centered" title="TOI shifts all situations">Shifts</th>
                <th  class="has-text-centered" title="TOI average shift time all situations">AvgShifts</th>
                <th  class="has-text-centered" title="TOI 5v5 time even handed">EH</th>
                <th  class="has-text-centered" title="TOI power play time"><span v-if="Fixture[0].away_team.name === 'Cardiff Devils'">SH </span> <span v-else>PP</span></th>
                <th  class="has-text-centered" title="TOI short handed time"><span v-if="Fixture[0].away_team.name === 'Cardiff Devils'">PP </span> <span v-else>SH</span></th>
                <th  class="has-text-centered" title="Total time on ice all situations">Total TOI</th>
              </thead>
              <tbody>
                <tr  v-for="result in sortBytimeDefense" v-bind:key="result.number">
                  <td class="tbl-name has-text-centered">{{result.number}}</td>
                  <td class="tbl-goal has-text-centered">{{result.goals_for}}</td>
                  <td class="tbl-goal has-text-centered">{{result.goals_against}}</td>
                  <td class="tbl-goal has-text-centered">{{result.goal_diff}}</td>
                  <td class="has-text-centered" >{{result.fo}}</td>
                  <td class="tbl-shots has-text-centered">{{result.shots_for}}</td>
                  <td class="tbl-shots has-text-centered">{{result.shots_against}}</td>
                  <td class="tbl-shots has-text-centered">{{result.shots_plus_minus}}</td>
                  <td class="has-text-centered" >{{result.sot}}</td>
                  <td class="has-text-centered" >{{result.shifts}}</td>
                  <td class="has-text-centered" >{{result.avg_shift}}</td>
                  <td class="has-text-centered" >{{result.eh_time}}</td>
                  <td class="has-text-centered" >{{result.pp_time}}</td>
                  <td class="has-text-centered" >{{result.sh_time}}</td>
                  <td class="has-text-centered" ><b>{{result.total_toi}}</b></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="title is-parent is-6 is-vertical" style="margin:0 auto;">
          <div class="block content">
            <h2 class="subtitle has-text-centered">Estimated TOI - For Away Games</h2>
            <table class="table is-responsive is-striped is-hoverable">
              <thead>
                <th  class="has-text-centered" title="Player Number">#</th>
                <th  class="has-text-centered" title="TOI shifts all situations">Shifts</th>
                <th  class="has-text-centered" title="TOI shifts all situations">Season AVG Shift</th>
                <th  class="has-text-centered" title="Est Time based on season average">EST Total TOI</th>
              </thead>
              <tbody>
                <tr  v-for="result in sortBytimeAll" v-bind:key="result.number">
                  <td class="tbl-name has-text-centered">{{result.number}}</td>
                  <td class="has-text-centered">{{result.shifts}}</td>
                  <td class="has-text-centered">{{result.season_average_toi}}</td>
                  <td class="has-text-centered" ><b>{{result.est_toi}}</b></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div  v-if="Fixture[0].is_stream == 1" class="title is-parent is-6 is-vertical" style="margin:0 auto;">
          <div class="block content">
            <h2 class="subtitle has-text-centered">Totals</h2>
            <table class="table is-responsive is-striped is-hoverable">
              <thead>
                <th  class="has-text-centered" title="Player Number">#</th>
                <th  class="has-text-centered" title="TOI goals for even handed">+</th>
                <th  class="has-text-centered" title="TOI goals against even handed">-</th>
                <th  class="has-text-centered" title="TOI goals +/- even handed">+/-</th>
                <th  class="has-text-centered" title="Faceoffs won / Faceoffs taken all situations">FO</th>
                <th  class="has-text-centered" title="TOI chances for even handed">Shots For</th>
                <th  class="has-text-centered" title="TOI chances against even handed">Shots Against</th>
                <th  class="has-text-centered" title="TOI chances +/- even handed">Shots Diff</th>
                <th  class="has-text-centered" title="Shots on target all situations">SOT</th>
                <th  class="has-text-centered" title="TOI shifts all situations">Shifts</th>
                <th  class="has-text-centered" title="TOI average shift time all situations">AvgShifts</th>
                <th  class="has-text-centered" title="TOI 5v5 time even handed">EH</th>
                <th  class="has-text-centered" title="TOI power play time"><span v-if="Fixture[0].away_team.name === 'Cardiff Devils'">SH </span> <span v-else>PP</span></th>
                <th  class="has-text-centered" title="TOI short handed time"><span v-if="Fixture[0].away_team.name === 'Cardiff Devils'">PP </span> <span v-else>SH</span></th>
                <th  class="has-text-centered" title="Total time on ice all situations">Total TOI</th>
              </thead>
              <tbody>
                <tr  v-for="result in gameTotals" v-bind:key="result.number">
                  <td class="tbl-name has-text-centered">{{result.number}}</td>
                  <td class="tbl-goal">{{result.total_gf}}</td>
                  <td class="tbl-goal">{{result.total_ga}}</td>
                  <td class="tbl-goal">{{result.total_gdiff}}</td>
                  <td class="has-text-centered" >{{result.total_fo}}</td>
                  <td class="tbl-shots">{{result.total_shots_for}}</td>
                  <td class="tbl-shots">{{result.total_shots_against}}</td>
                  <td class="tbl-shots">{{result.total_shots_for - result.total_shots_against}}</td>
                  <td class="has-text-centered" >{{result.total_sot}}</td>
                  <td class="has-text-centered">{{result.total_shifts}}</td>
                  <td class="has-text-centered" >-</td>
                  <td class="has-text-centered" >{{result.total_eh}}</td>
                  <td class="has-text-centered" >{{result.total_pp}}</td>
                  <td class="has-text-centered" >{{result.total_sh}}</td>
                  <td class="has-text-centered" ><b>{{result.total_toi}}</b></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>


<script>
// import simpleheat from '../../store/modules/simpleheat/simpleheat'
// import randomColor from '../../store/modules/utils/randomColor'
import Slider from 'vue-bulma-slider'
import Chart from 'vue-bulma-chartjs'
import moment from 'moment'
import SubTable from './sub-table.vue'
import ShotDiffTime from './shot-diff-time.vue'
import FaceoffTeamVS from './faceoff-team-vs.vue'
import ShotsHeatmap from './shots-heatmap.vue'
import ShotsQuality from './shots-quality.vue'
import FaceoffsPVP from './season-stats/faceoffs-pvp.vue'
import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse'
import _ from 'lodash'
export default {
  name: 'player',
  components: {
    Slider,
    Chart,
    Collapse,
    CollapseItem,
    'sub-table': SubTable,
    'shot-diff-time': ShotDiffTime,
    'FaceoffTeamVS': FaceoffTeamVS,
    'ShotsHeatmap': ShotsHeatmap,
    'shot-quality': ShotsQuality,
    'faceoffs-pvp': FaceoffsPVP
  },
  data () {
    return {
      period: 1,
      Faceoffs: [],
      Shots: [],
      OddmanRushes: [],
      Fixture: [],
      SOT: [],
      Gamesheet: [],
      Hits: [],
      PlusMinus: [],
      PlusMinusAuto: [],
      FaceoffsChart: [],
      homeShotLocationData: [],
      Summary: [],
      bar_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              callback: function (value) {
                if (value % 1 === 0) {
                  return value
                }
              }
            }
          }]
        }
      },
      pie_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        responsive: true
      },
      sot_bar_options: {
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: false,
            barPercentage: 1.4,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: false,
            barPercentage: 1.4,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              callback: function (value) {
                if (value % 1 === 0) {
                  return value
                }
              }
            }
          }]
        }
      },
      fo_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true,
              beginAtZero: true,
              callback: function (value) {
                if (value % 1 === 0) {
                  return value
                }
              }
            }
          }]
        }
      },
      fo_total_options: {

      },
      shots_horz_bar_options: {
        title: {
          display: false
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true,
              beginAtZero: true,
              callback: function (value) {
                if (value % 1 === 0) {
                  return value
                }
              }
            }
          }]
        }
      },
      backgroundColor: [
        '#1fc8db',
        '#fce473',
        '#42afe3',
        '#ed6c63',
        '#97cd76'
      ],
      isFaceoffsPvp: false,
      isFaceoffOpen: true,
      homeZoneShots: [],
      awayZoneShots: [],
      shotmapSituations: [
        {
          text: 'All',
          value: -1
        },
        {
          text: 'Even Handed',
          value: 'EvenHanded'
        },
        {
          text: 'Power Play',
          value: 'PowerPlay'
        },
        {
          text: 'Short Handed',
          value: 'PenaltyKill'
        }
      ],
      shotTypeOptions: [
        {
          text: 'All',
          value: -1
        },
        {
          text: 'Goals',
          value: 'Goal'
        },
        {
          text: 'On Net',
          value: 'OnNet'
        },
        {
          text: 'Missed Target',
          value: 'MissedNet'
        },
        {
          text: 'Blocked',
          value: 'Blocked'
        }
      ],
      plusMinusOptions: [
        {
          text: 'Line',
          value: 'line'
        },
        {
          text: 'Differential',
          value: 'differential'
        },
        {
          text: 'Shots For',
          value: 'for'
        },
        {
          text: 'Shots Against',
          value: 'against'
        }
      ],
      sotOptions: [
        {
          text: 'All Situations',
          value: 'all'
        },
        {
          text: 'Even Handed',
          value: 'eh'
        },
        {
          text: 'Power Play',
          value: 'pp'
        },
        {
          text: 'Short Handed',
          value: 'sh'
        }
      ],
      selectedSOTSort: 'eh',
      selectedPlusMinusSort: 'line',
      selectedShotType: 'OnNet',
      selectedShotSituation: 'EvenHanded',
      selectedHitSort: 'eh',
      Turnovers: []
    }
  },
  computed: {
    sortBytimeGT: function () {
     /*eslint-disable */
      let gt = this.Gamesheet.filter(a => a.position == 'GT')
      return gt.slice().sort(function (a, b) { 
        return moment(b.total_toi,'HH:mm:ss') - moment(a.total_toi,'HH:mm:ss')
      })
    },
    sortBytimeDefense: function () {
     /*eslint-disable */
      let defense = this.Gamesheet.filter(a => a.position == 'LD' || a.position == 'RD')
      return defense.slice().sort(function (a, b) {
        return moment(b.total_toi,'HH:mm:ss') - moment(a.total_toi,'HH:mm:ss')
      })
    },
    sortBytimeForwards: function () {
      let forwards = this.Gamesheet.filter(a => a.position == 'LW' || a.position == 'C' || a.position =='RW')
      return forwards.slice().sort(function (a, b) { 
        return moment(b.total_toi,'HH:mm:ss') - moment(a.total_toi,'HH:mm:ss')
      })
    },
    sortBytimeAll: function () {
      let all = this.Gamesheet.filter(a => a.position == 'LW' || a.position == 'C' || a.position =='RW' || a.position == 'LD' || a.position == 'RD')
      return all.slice().sort(function (a, b) {
        return moment(b.total_toi,'HH:mm:ss') - moment(a.total_toi,'HH:mm:ss')
      })
    },
    sortFoByDiffLeft: function () {
      // console.log(_.orderBy(this.FaceoffsChart.all_situations, ['total_diff_left'], ['desc']))
      return _.orderBy(this.FaceoffsChart.all_situations, ['total_diff_left'], ['desc'])
    },
    sortFoByDiffCenter: function () {
      // console.log(_.orderBy(this.FaceoffsChart.all_situations, ['total_diff_center'], ['desc']))
      return _.orderBy(this.FaceoffsChart.all_situations, ['total_diff_center'], ['desc'])
    },
    sortFoByDiffRight: function () {
      // console.log(_.orderBy(this.FaceoffsChart.all_situations, ['total_diff_right'], ['desc']))
      return _.orderBy(this.FaceoffsChart.all_situations, ['total_diff_right'], ['desc'])
    },
    sortByTOAscEH: function() {
      return _.orderBy(this.Turnovers.home_players,['pos','total_eh','player_defensive_eh','player_neutral_eh','player_offensive_eh'],['asc','desc','desc','desc','desc'])
    },
    sortByTOAscPP: function() {
      return _.orderBy(this.Turnovers.home_players,['pos','total_pp','player_defensive_pp','player_neutral_pp','player_offensive_pp'],['asc','desc','desc','desc','desc'])
    },
    sortByTOAscSH: function() {
      return _.orderBy(this.Turnovers.home_players,['pos','total_sh','player_defensive_sh','player_neutral_sh','player_offensive_sh'],['asc','desc','desc','desc','desc'])
    },
    sortByHits: function() {
      if (this.selectedHitSort === 'eh') {
        return _.orderBy(this.Hits.home_players,['hits_eh', 'asc'])
      } else if (this.selectedHitSort === 'pp') {
        return _.orderBy(this.Hits.home_players,['hits_pp', 'asc'])
      } else if (this.selectedHitSort === 'sh') {
        return _.orderBy(this.Hits.home_players,['hits_sh', 'asc'])
      } else if (this.selectedHitSort === 'all') {
        return _.orderBy(this.Hits.home_players,['hit_total', 'asc'])
      } else 
      {
        return this.Hits.home_players
      }
    },
    sortBySOT: function() {
      if (this.selectedSOTSort === 'eh'){
        return _.orderBy(this.SOT.home_players,['sot_eh'],['asc'])
      } else if (this.selectedSOTSort === 'pp') {
        return _.orderBy(this.SOT.home_players,['sot_pp'],['asc'])
      } else if (this.selectedSOTSort === 'sh') {
        return _.orderBy(this.SOT.home_players,['sot_sh'],['asc'])
      }else if (this.selectedSOTSort === 'all') {
        return _.orderBy(this.SOT.home_players,['sot_total'],['asc'])
      } else 
      {
        return this.SOT.home_players
      }
    },
    sortBySOTAway: function() {
      if (this.selectedSOTSort === 'eh'){
        return _.orderBy(this.SOT.away_players,['sot_eh'],['desc'])
      } else if (this.selectedSOTSort === 'pp') {
        return _.orderBy(this.SOT.away_players,['sot_pp'],['desc'])
      } else if (this.selectedSOTSort === 'sh') {
        return _.orderBy(this.SOT.away_players,['sot_sh'],['desc'])
      } else if (this.selectedSOTSort === 'all') {
        return _.orderBy(this.SOT.away_players,['sot_total'],['desc'])
      } else 
      {
        return this.SOT.away_players
      }
    },
    sortByPlusMinusHomeAuto: function() {
      // console.log('Plus minus sort option is: '  + this.selectedPlusMinusSort)
      if (this.selectedPlusMinusSort === 'line'){
        // console.log('Plus minus data: ' + JSON.stringify(this.PlusMinus.home_players))
        return _.orderBy(this.PlusMinusAuto.home_players, ['pos', 'line_number'], ['asc', 'asc'])
      } else if (this.selectedPlusMinusSort === 'differential')  {
        console.log(JSON.stringify(_.orderBy(this.PlusMinusAuto.home_players,['pos','diff'],['asc','desc'])))
        return _.orderBy(this.PlusMinusAuto.home_players, ['pos', 'diff'], ['asc', 'desc'])
      } else if (this.selectedPlusMinusSort === 'for') {
        return _.orderBy(this.PlusMinusAuto.home_players, ['pos', 'shots_for'], ['asc', 'desc'])
      } else if (this.selectedPlusMinusSort === 'against') {
        return _.orderBy(this.PlusMinusAuto.home_players, ['pos', 'shots_against'], ['asc', 'desc'])
      } else 
      {
        return this.PlusMinusAuto.home_players
      }
    },
    sortByPlusMinusHomeAutoDiff: function() {
      return _.orderBy(this.PlusMinusAuto.home_players, ['pos', 'diff'], ['asc', 'desc'])
    },
    fo_total_chart () {
      return {
        labels: this.fo_total_labels,
        datasets: [{
          data: this.getFoChartTotals(),
          backgroundColor: this.backgroundColor
        }]
      }
    },

    fo_player_l () {
      let playerLabels = []
      for (var label of this.sortFoByDiffLeft) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerLeftWin = []
      for (var leftWin of this.sortFoByDiffLeft) {
        playerLeftWin.push(leftWin.left_win)
      }
      let playerLeftLoss = []
      for (var leftLoss of this.sortFoByDiffLeft) {
        playerLeftLoss.push(leftLoss.left_loss)
      }
      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      },
      {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }
      ]
      return data
    },
    fo_player_c () {
      let playerLabels = []
      for (var label of this.sortFoByDiffCenter) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerCenterWin = []
      for (var center of this.sortFoByDiffCenter) {
        playerCenterWin.push(center.center_win)
      }
      let playerCenterLoss = []
      for (var centerLoss of this.sortFoByDiffCenter) {
        playerCenterLoss.push(centerLoss.center_loss)
      }
      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      },
      {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }]
      return data
    },
    fo_player_r () {
      let playerLabels = []
      for (var label of this.sortFoByDiffRight) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerRightWin = []
      for (var right of this.sortFoByDiffRight) {
        playerRightWin.push(right.right_win)
      }
      let playerRightLoss = []
      for (var rightLoss of this.sortFoByDiffRight) {
        playerRightLoss.push(rightLoss.right_loss)
      }
      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      },
      {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }]
      return data
    },
    fo_player_t () {
      if (this.FaceoffsChart.all_situations) {
        let playerLabels = []
        for (var label of this.FaceoffsChart.all_situations) {
          playerLabels.push(label.player_id)
        }
        let data = {
          labels: playerLabels
        }
        data.datsets = []
        let playerTotalWin = []
        for (var win of this.FaceoffsChart.all_situations) {
          playerTotalWin.push(win.total_win)
        }
        let playerTotalLoss = []
        for (var loss of this.FaceoffsChart.all_situations) {
          playerTotalLoss.push(loss.total_loss)
        }
        data.datasets = [{
          data: playerTotalWin,
          label: 'Total Win',
          backgroundColor: 'rgba(255, 206, 86, 1)',
          borderColor: 'rgba(255, 206, 86, 1)'
        },
        {
          data: playerTotalLoss,
          label: 'Total Loss',
          backgroundColor: 'rgba(255, 99, 132, 1)',
          borderColor: 'rgba(255, 99, 132, 1)'
        }]
        return data
      }
    },
    fo_player_l_eh () {
      let playerLabels = []
      for (var label of this.FaceoffsChart.eh_situations) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerLeftWin = []
      for (var leftWin of  this.FaceoffsChart.eh_situations) {
        playerLeftWin.push(leftWin.left_win)
      }
      let playerLeftLoss = []
      for (var leftLoss of  this.FaceoffsChart.eh_situations) {
        playerLeftLoss.push(leftLoss.left_loss)
      }
      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      },
      {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }
      ]
      return data
    },
    fo_player_c_eh () {
      let playerLabels = []
      for (var label of  this.FaceoffsChart.eh_situations) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerCenterWin = []
      for (var center of  this.FaceoffsChart.eh_situations) {
        playerCenterWin.push(center.center_win)
      }
      let playerCenterLoss = []
      for (var centerLoss of  this.FaceoffsChart.eh_situations) {
        playerCenterLoss.push(centerLoss.center_loss)
      }
      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      },
      {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }]
      return data
    },
    fo_player_r_eh () {
      let playerLabels = []
      for (var label of  this.FaceoffsChart.eh_situations) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerRightWin = []
      for (var right of  this.FaceoffsChart.eh_situations) {
        playerRightWin.push(right.right_win)
      }
      let playerRightLoss = []
      for (var rightLoss of  this.FaceoffsChart.eh_situations) {
        playerRightLoss.push(rightLoss.right_loss)
      }
      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      },
      {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }]
      return data
    },
    fo_player_l_pp () {
      let playerLabels = []
      for (var label of  this.FaceoffsChart.pp_situations) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerLeftWin = []
      for (var leftWin of this.FaceoffsChart.pp_situations) {
        playerLeftWin.push(leftWin.left_win)
      }
      let playerLeftLoss = []
      for (var leftLoss of this.FaceoffsChart.pp_situations) {
        playerLeftLoss.push(leftLoss.left_loss)
      }
      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      },
      {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }
      ]
      return data
    },
    fo_player_c_pp () {
      let playerLabels = []
      for (var label of this.FaceoffsChart.pp_situations) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerCenterWin = []
      for (var center of this.FaceoffsChart.pp_situations) {
        playerCenterWin.push(center.center_win)
      }
      let playerCenterLoss = []
      for (var centerLoss of this.FaceoffsChart.pp_situations) {
        playerCenterLoss.push(centerLoss.center_loss)
      }
      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      },
      {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }]
      return data
    },
    fo_player_r_pp () {
      let playerLabels = []
      for (var label of this.FaceoffsChart.pp_situations) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerRightWin = []
      for (var right of this.FaceoffsChart.pp_situations) {
        playerRightWin.push(right.right_win)
      }
      let playerRightLoss = []
      for (var rightLoss of this.FaceoffsChart.pp_situations) {
        playerRightLoss.push(rightLoss.right_loss)
      }
      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      },
      {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }]
      return data
    },
    fo_player_l_sh () {
      let playerLabels = []
      for (var label of this.FaceoffsChart.sh_situations) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerLeftWin = []
      for (var leftWin of this.FaceoffsChart.sh_situations) {
        playerLeftWin.push(leftWin.left_win)
      }
      let playerLeftLoss = []
      for (var leftLoss of this.FaceoffsChart.sh_situations) {
        playerLeftLoss.push(leftLoss.left_loss)
      }
      data.datasets = [{
        data: playerLeftWin,
        label: 'Left Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      },
      {
        data: playerLeftLoss,
        label: 'Left Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }
      ]
      return data
    },
    fo_player_c_sh () {
      let playerLabels = []
      for (var label of this.FaceoffsChart.sh_situations) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerCenterWin = []
      for (var center of this.FaceoffsChart.sh_situations) {
        playerCenterWin.push(center.center_win)
      }
      let playerCenterLoss = []
      for (var centerLoss of  this.FaceoffsChart.sh_situations) {
        playerCenterLoss.push(centerLoss.center_loss)
      }
      data.datasets = [{
        data: playerCenterWin,
        label: 'Center Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      },
      {
        data: playerCenterLoss,
        label: 'Center Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }]
      return data
    },
    fo_player_r_sh () {
      let playerLabels = []
      for (var label of this.FaceoffsChart.sh_situations) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerRightWin = []
      for (var right of this.FaceoffsChart.sh_situations) {
        playerRightWin.push(right.right_win)
      }
      let playerRightLoss = []
      for (var rightLoss of this.FaceoffsChart.sh_situations) {
        playerRightLoss.push(rightLoss.right_loss)
      }
      data.datasets = [{
        data: playerRightWin,
        label: 'Right Win',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      },
      {
        data: playerRightLoss,
        label: 'Right Loss',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }]
      return data
    },
    to_player_eh () {
      let playerLabels = []
      for (var label of this.sortByTOAscEH) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerOffensive = []
      let playerNeutral = []
      let playerDefensive = []
      for (var offensive of this.sortByTOAscEH) {
        playerOffensive.push(offensive.player_offensive_eh)
      }
      for (var neutral of this.sortByTOAscEH) {
        playerNeutral.push(neutral.player_neutral_eh)
      }
      for (var defensive of this.sortByTOAscEH) {
        playerDefensive.push(defensive.player_defensive_eh)
      }
      data.datasets = [{
        data: playerDefensive,
        label: 'Defensive',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: playerNeutral,
        label: 'Neutral',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54,162,235, 1)'
      },
      {
        data: playerOffensive,
        label: 'Offensive',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    to_player_pp () {
      let playerLabels = []
      for (var label of this.sortByTOAscPP) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerOffensive = []
      let playerNeutral = []
      let playerDefensive = []
      for (var offensive of this.sortByTOAscPP) {
        playerOffensive.push(offensive.player_offensive_pp)
      }
      for (var neutral of this.sortByTOAscPP) {
        playerNeutral.push(neutral.player_neutral_pp)
      }
      for (var defensive of this.sortByTOAscPP) {
        playerDefensive.push(defensive.player_defensive_pp)
      }
      data.datasets = [{
        data: playerDefensive,
        label: 'Defensive',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: playerNeutral,
        label: 'Neutral',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54,162,235, 1)'
      },
      {
        data: playerOffensive,
        label: 'Offensive',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    to_player_sh () {
      let playerLabels = []
      for (var label of this.sortByTOAscSH) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerOffensive = []
      let playerNeutral = []
      let playerDefensive = []
      for (var offensive of this.sortByTOAscSH) {
        playerOffensive.push(offensive.player_offensive_sh)
      }
      for (var neutral of this.sortByTOAscSH) {
        playerNeutral.push(neutral.player_neutral_sh)
      }
      for (var defensive of this.sortByTOAscSH) {
        playerDefensive.push(defensive.player_defensive_sh)
      }
      data.datasets = [{
        data: playerDefensive,
        label: 'Defensive',
        backgroundColor: 'rgba(255, 99, 132, 1)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: playerNeutral,
        label: 'Neutral',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54,162,235, 1)'
      },
      {
        data: playerOffensive,
        label: 'Offensive',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    hit_player_totals () {
      let playerLabels = []
      for (var label of this.sortByHits) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerHits = []
      for (var hits of this.sortByHits) {
        if (this.selectedHitSort === 'eh')
          playerHits.push(hits.hits_eh)
        if (this.selectedHitSort === 'pp')
          playerHits.push(hits.hits_pp)
        if (this.selectedHitSort === 'sh')
          playerHits.push(hits.hits_sh)
        if (this.selectedHitSort === 'all')
          playerHits.push(hits.hit_total)
      }
      data.datasets = [{
        data: playerHits,
        label: 'Hits',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }]
      return data
    },
    oddman_rushes_totals () {
      let playerLabels = []
      for (var label of this.FaceoffsChart.sh_situations) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: [this.Fixture[0].home_team.name, this.Fixture[0].away_team.name]
      }
      data.datsets = []

      data.datasets = [{
        data: [this.OddmanRushes.home_rushes, this.OddmanRushes.away_rushes],
        backgroundColor: ['rgba(255, 206, 86, 1)', 'rgba(54, 162, 235, 1)'],
        borderColor: ['rgba(255, 206, 86, 1)', 'rgba(54, 162, 235, 1)']
      }]
      return data
    },
    sot_totals_home () {
      let playerLabels = []
      for (var label of this.sortBySOT) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let shotsOnTarget = []
      for (var shot of this.sortBySOT) {
        shotsOnTarget.push(shot.sot)
      }
      data.datasets = [{
        data: shotsOnTarget,
        label: 'Shots On Target - EH',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }]
      return data
    },
    sot_totals_away () {
      let playerLabels = []
      // console.log('SOT AWAY: ' + JSON.stringify(this.SOT.away_players))
      for (var label of this.sortBySOTAway) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let shotsOnTarget = []
      for (var shot of this.sortBySOTAway) {
        shotsOnTarget.push(shot.sot)
      }
      data.datasets = [{
        data: shotsOnTarget,
        label: 'Shots On Target - EH',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }]
      return data
    },
    sot_totals () {
      let playerLabels = []
      let shotsOnTarget = []
      let shotsOnTargetAway = []
      // console.log('SOT AWAY: ' + JSON.stringify(this.SOT.away_players))

      for (var label of this.sortBySOT) {
        playerLabels.push(label.player_id)
      }
      for (var label of this.sortBySOTAway) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      for (var shot of this.sortBySOT) {
        if (this.selectedSOTSort === 'eh'){
          shotsOnTarget.push(shot.sot_eh)
        }
        else if (this.selectedSOTSort === 'pp'){
          shotsOnTarget.push(shot.sot_pp)
        }
        else if (this.selectedSOTSort === 'sh'){
          shotsOnTarget.push(shot.sot_sh)
        }
        else if (this.selectedSOTSort === 'all'){
          shotsOnTarget.push(shot.sot_total)
        }
      }
      for (var shot of this.sortBySOTAway) {
        shotsOnTarget.push(0)
      }
      for (var shot of this.sortBySOT) {
        shotsOnTargetAway.push(0)
      }
      for (var shot of this.sortBySOTAway) {
        if (this.selectedSOTSort === 'eh'){
          shotsOnTargetAway.push(shot.sot_eh)
        }
        else if (this.selectedSOTSort === 'pp'){
          shotsOnTargetAway.push(shot.sot_pp)
        }
        else if (this.selectedSOTSort === 'sh'){
          shotsOnTargetAway.push(shot.sot_sh)
        }
        else if (this.selectedSOTSort === 'all'){
          shotsOnTargetAway.push(shot.sot_total)
        }
      }

      data.datsets = []
      data.datasets = [{
        data: shotsOnTarget,
        label: this.Fixture[0].home_team.name,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      },
      {
        data: shotsOnTargetAway,
        label: this.Fixture[0].away_team.name,
        backgroundColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    plus_minus_auto_totals () {
      let playerLabels = []
      for (var label of this.sortByPlusMinusHomeAuto) {
        if (label.player_id !== 'Team')
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let shotsFor = []
      let shotsAgainst = []
      for (var shots of this.sortByPlusMinusHomeAuto) {
        if (shots.player_id !== 'Team')
        shotsFor.push(shots.shots_for)
      }
      for (var shotsA of this.sortByPlusMinusHomeAuto) {
        if (shotsA.player_id !== 'Team')
        shotsAgainst.push(shotsA.shots_against)
      }
      data.datasets = [{
        data: shotsFor,
        label: 'Shots For',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      },
      {
        data: shotsAgainst,
        label: 'Shots Against',
        backgroundColor: 'rgba(255, 206, 86, 1)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    plus_minus_auto_diff () {
      let playerLabels = []
      for (var label of this.sortByPlusMinusHomeAutoDiff) {
        if (label.player_id !== 'Team')
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let shotsFor = []
      let shotsAgainst = []
      for (var shots of this.sortByPlusMinusHomeAutoDiff) {
        if (shots.player_id !== 'Team')
        shotsFor.push(shots.diff)
      }
      data.datasets = [{
        data: shotsFor,
        label: 'Differential',
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }]
      return data
    },
    fo_total_chart () {
      return {
        labels: this.fo_total_labels,
        datasets: [{
          data: this.getFoChartTotals(),
          backgroundColor: this.backgroundColor
        }]
      }
    },
    cleanPlusMinusData () {
      let cleanData = []
      // console.log(this.TOI[0])
      
      _.map(this.sortByPlusMinusHomeAuto, function (object) {
        cleanData.push(_.pick(object, ['player_id', 'shots_for', 'shots_against']))
      })
      return cleanData
    },
    gameTotals: function() {
      let total = []
      for (var v of this.Gamesheet){
        if (v.position === 'total') {
          total.push(v)
        }
      }
      return total
    }
  },
  methods: {
    setPeriod (newPeriod) {
      this.$router.push('/stats/match-stats-opposition/' + this.$route.params.gameId + '/' + newPeriod)
      this.updateRemotes()
      this.$router.go(0)
    },
    fetchGameSummary() {
      this.$http
        .get('https://devilsapi.roblutken.com/api/app/get/game-summary/' + this.$route.params.gameId + '/' + this.$route.params.period, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
        })
        .then(
          response => {
            this.Summary = response.data
            console.log(JSON.stringify(this.Summary.situation_opts[0]))
          },
          response => {}
        )
    },
    fetchGamesheet () {
      this.$http
        .get('https://devilsapi.roblutken.com/api/app/get/match-stats/opposition/' + this.$route.params.gameId + '/' + this.$route.params.period, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
        })
        .then(
          response => {
            this.Gamesheet = response.data
          },
          response => {}
        )
    },
    fetchHitTotals () {
      this.teamId = this.$route.params.teamId
      this.$http
        .get(
          'https://devilsapi.roblutken.com/api/app/get/match-stats/hits/opposition/' + this.$route.params.gameId + '/' + this.$route.params.period,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            this.Hits = response.data
          },
          response => {}
        )
    },
    fetchTurnoverTotals () {
      this.$http
        .get(
          'https://devilsapi.roblutken.com/api/app/get/match-stats/turnovers/opposition/' + this.$route.params.gameId + '/' + this.$route.params.period,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            this.Turnovers = response.data
            // console.log(JSON.stringify(this.Turnovers))
          },
          response => {}
        )
    },
    fetchPlusMinusTotals () {
      this.$http
        .get(
          'https://devilsapi.roblutken.com/api/app/get/match-stats/plus_minus/' + this.$route.params.gameId + '/' + this.$route.params.period,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            this.PlusMinus = response.data
          },
          response => {}
        )
    },
    fetchSOTTotals () {
      this.$http
        .get(
          'https://devilsapi.roblutken.com/api/app/get/match-stats/individualsot/' + this.$route.params.gameId + '/' + this.$route.params.period,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            this.SOT = response.data
          },
          response => {}
        )
    },
    fetchPlusMinusAutoTotals () {
      this.$http
        .get(
          'https://devilsapi.roblutken.com/api/app/get/match-stats/plus_minus_auto/opposition/' + this.$route.params.gameId + '/' + this.$route.params.period,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            this.PlusMinusAuto = response.data
          },
          response => {}
        )
    },
    fetchFaceoffTotals () {
      // console.log('Get faceoff totals')
      this.teamId = this.$route.params.teamId
      this.$http
        .get(
          'https://devilsapi.roblutken.com/api/faceoffs/season/get/totals/',
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            // console.log('Faceoff Data is ' + response.data)
            this.Faceoffs = response.data
           // console.log(JSON.stringify(this.Faceoffs))
          },
          response => {}
        )
    },
    fetchFaceoffChart () {
      this.$http
        .get(
          'https://devilsapi.roblutken.com/api/app/get/match-stats/faceoffs/opposition/' + this.$route.params.gameId + '/' + this.$route.params.period,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
           // console.log('Faceoff Data is ' + JSON.stringify(response.data))
            this.FaceoffsChart = response.data
           // console.log(JSON.stringify(this.Faceoffs))
          },
          response => {}
        )
    },
    getFoChartTotals () {
      let foData = [this.Faceoffs.total_wins, this.Faceoffs.total_losses]
      return foData
    },
    fetchFixtures () {
      this.$http.get('https://devilsapi.roblutken.com/api/games/get/single/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        // console.log('Data is ' + response.data)
        this.Fixture = response.data
        // console.log(JSON.stringify(this.Fixture))
      }, response => {
      })
    },
    fetchRushes () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/match-stats/oddman-rushes/' + this.$route.params.gameId + '/' + this.$route.params.period, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        // console.log('Data is ' + response.data)
        this.OddmanRushes = response.data
        // console.log(JSON.stringify(this.OddmanRushes))
      }, response => {
      })
    },
    updateRemotes () {
      this.fetchFixtures()
      this.fetchGameSummary()
      this.fetchFaceoffTotals()
      this.fetchTurnoverTotals()
      this.fetchHitTotals()
      this.fetchGamesheet()
      this.fetchPlusMinusTotals()
      this.fetchPlusMinusAutoTotals()
      this.fetchSOTTotals()
      this.fetchFaceoffChart()
      this.fetchRushes()
    },
    fetchShotmap () {
      this.awayZoneShots = []
      this.homeZoneShots= []
      this.renderKey()
      this.$http
        .get(
          'https://devilsapi.roblutken.com/api/app/get/match-stats/shots/' + this.$route.params.gameId + '/' + this.$route.params.period,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            this.awayZoneShots = []
            this.homeZoneShots = []
            setTimeout(() => {
              this.renderZoneMap('home',this.$refs.home_shots_canvas,response.data.home_shot_locations)
            }, 3050)

            setTimeout(() => {
              this.renderZoneMap('away',this.$refs.away_shots_canvas,response.data.away_shot_locations)
            }, 3050)
          },
          response => {}
        )
    },
    renderKey () {
      var canvas = this.$refs.shotmap_key
      var ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      this.drawCircle(ctx, '#0fe800', [50, 10], 8)
      this.drawCircle(ctx, '#D90908F2', [100, 10], 6)
      this.drawCircle(ctx, '#e8a600', [150, 10], 4)
      this.drawCircle(ctx, '#6800e8', [200, 10], 4)
      this.drawText (ctx, 'Goal', [35,30], '12px')
      this.drawText (ctx, 'On Net', [85,30], '12px')
      this.drawText (ctx, 'Missed', [136,30], '12px')
      this.drawText (ctx, 'Blocked', [185,30], '12px')
    },
    renderZoneMap (team,teamShotmap,locatonData) {
      // console.log('Render shotmap' + teamShotmap + locatonData)
      var canvas = teamShotmap
      var ctx = canvas.getContext('2d')

      ctx.clearRect(0, 0, canvas.width, canvas.height)
      let colour = '#2F4858C9'
      let centerPos = [160, 76, 280, 200]
      let centerPosText = [280, 200]
      let centerCount = 0

      let outsideZonePos = [5, 389, 590, 140]
      let outsideZoneText = [480, 520]
      let outsideCount = 0

      let behindNetPos = [5, 0, 590, 75]
      let behindNetText = [480, 70]
      let behindNetCount = 0

      let leftOutsidePos = [5, 76, 160, 200]
      let leftOutsideText = [80, 80]
      let leftOutsideCount = 0

      let rightOutsidePos = [440, 76, 155, 200]
      let rightOutsideText = [445, 80]
      let rightOutsideCount = 0

      let leftPointInit = [5, 275]
      let leftPointTextPos = [10, 320]
      let leftPointLines = [{x: 5, y: 275}, {x: 165, y: 275}, {x: 180, y: 385}, {x: 5, y: 385}, {x: 5, y: 275}]
      let leftPointCount = 0

      let centerPointInit = [165, 275]
      let centerPointTextPos = [230, 320]
      let centerPointLines = [{x: 165, y: 275}, {x: 440, y: 275}, {x: 420, y: 385}, {x: 180, y: 385}, {x: 165, y: 275}]
      let centerPointCount = 0

      let rightPointInit = [440, 275]
      let rightPointLines = [{x: 440, y: 275}, {x: 595, y: 275}, {x: 595, y: 385}, {x: 420, y: 385}, {x: 440, y: 275}]
      let rightPointTextPos = [445, 320]
      let rightPointCount = 0

      this.drawRect(ctx, colour, centerPos)
      this.drawRect(ctx, colour, outsideZonePos, '12px', 1)
      this.drawRect(ctx, colour, behindNetPos)
      this.drawRect(ctx, colour, leftOutsidePos)
      this.drawRect(ctx, colour, rightOutsidePos)

      this.drawCustom(ctx, colour, leftPointInit, leftPointLines)
      this.drawCustom(ctx, colour, centerPointInit, centerPointLines)
      this.drawCustom(ctx, colour, rightPointInit, rightPointLines)

      for (var shots of locatonData) {
        if (this.selectedShotType === -1 && this.selectedShotSituation === -1 
        || this.selectedShotType === -1 && shots.situation === this.selectedShotSituation ||
        this.selectedShotSituation === -1 && shots.shot_type === this.selectedShotType ||
        shots.shot_type === this.selectedShotType  && shots.situation === this.selectedShotSituation || shots.shot_type === 'Goal' && this.selectedShotType ==='OnNet') {
          // console.log('Shot type is: ' + this.selectedShotType + ' and situation is: ' + this.selectedShotSituation)
          // console.log ('Actual : '  + shots.shot_type + ' situation: ' + shots.situation)
          let circlePos = []
          let decode = JSON.parse(shots.location)
          circlePos[0] = decode[0]
          circlePos[1] = decode[1]
          if (circlePos[0] >= 0.0 && circlePos[0] <= 160.0 && circlePos[1] > 76.0 && circlePos[1] < 270.0) {
            leftOutsideCount++
          }        // Red Zone
          if (circlePos[0] >= 160.0 && circlePos[0] <= 440.0 && circlePos[1] > 76.0 && circlePos[1] < 276.0) {
            centerCount++
          }
          if (circlePos[0] >= 440.0 && circlePos[0] <= 600.0 && circlePos[1] > 76.0 && circlePos[1] < 276.0) {
            rightOutsideCount++
          }
          if (circlePos[0] >= 0 && circlePos[0] <= 600.0 && circlePos[1] > 0 && circlePos[1] < 75.0) {
            behindNetCount++
          }
          if (circlePos[0] >= 0 && circlePos[0] <= 160.0 && circlePos[1] > 276.0 && circlePos[1] < 385.0) {
            leftPointCount++
          }
          if (circlePos[0] >= 420 && circlePos[0] <= 600.0 && circlePos[1] > 276.0 && circlePos[1] < 385.0) {
            rightPointCount++
          }
          if (circlePos[0] >= 160.0 && circlePos[0] <= 420.0 && circlePos[1] > 276.0 && circlePos[1] < 385.0) {
            centerPointCount++
          }
          if (circlePos[0] >= 0 && circlePos[0] <= 600 && circlePos[1] > 389 && circlePos[1] < 529) {
            outsideCount++
          }

          if (shots.shot_type === 'OnNet'){
            this.drawCircle(ctx, '#D90908F2', circlePos, 6)
          }
          if (shots.shot_type === 'Blocked'){
            this.drawCircle(ctx, '#6800e8', circlePos, 4)
          }
          if (shots.shot_type === 'MissedNet'){
            this.drawCircle(ctx, '#e8a600', circlePos, 4)
          }
          if (shots.shot_type === 'Goal'){
            this.drawCircle(ctx, '#0fe800', circlePos, 8)
          }
        }
      
      }
      if (team === 'home')
      {
        var shot = {
          zone: "Behind Net",
          count: behindNetCount
        }
        this.homeZoneShots.push(shot)
        shot = {
          zone: "Red Zone",
          count: centerCount
        }
        this.homeZoneShots.push(shot)
        shot = {
          zone: "Left Outside",
          count: leftOutsideCount
        }
        this.homeZoneShots.push(shot)
        shot = {
          zone: "Right Outside",
          count: rightOutsideCount
        }
        this.homeZoneShots.push(shot)
        shot = {
          zone: "Left Point",
          count: leftPointCount
        }
        this.homeZoneShots.push(shot)
        shot = {
          zone: "Center Point",
          count: centerPointCount
        }
        this.homeZoneShots.push(shot)
        shot = {
          zone: "Right Point",
          count: rightPointCount
        }
        this.homeZoneShots.push(shot)
        shot = {
          zone: "Outside Zone",
          count: outsideCount
        }
        this.homeZoneShots.push(shot)
        shot = {
          zone: "Total",
          count: centerCount + rightPointCount + leftPointCount + rightOutsideCount + leftOutsideCount
          + centerPointCount + behindNetCount + outsideCount
        }
        this.homeZoneShots.push(shot)
      }else {
        var shot = {
          zone: "Behind Net",
          count: behindNetCount
        }
        this.awayZoneShots.push(shot)
        shot = {
          zone: "Red Zone",
          count: centerCount
        }
        this.awayZoneShots.push(shot)
        shot = {
          zone: "Left Outside",
          count: leftOutsideCount
        }
        this.awayZoneShots.push(shot)
        shot = {
          zone: "Right Outside",
          count: rightOutsideCount
        }
        this.awayZoneShots.push(shot)
        shot = {
          zone: "Left Point",
          count: leftPointCount
        }
        this.awayZoneShots.push(shot)
        shot = {
          zone: "Center Point",
          count: centerPointCount
        }
        this.awayZoneShots.push(shot)
        shot = {
          zone: "Right Point",
          count: rightPointCount
        }
        this.awayZoneShots.push(shot)
        shot = {
          zone: "Outside Zone",
          count: outsideCount
        }
        this.awayZoneShots.push(shot)
        shot = {
          zone: "Total",
          count: centerCount + rightPointCount + leftPointCount + rightOutsideCount + leftOutsideCount
          + centerPointCount + behindNetCount + outsideCount
        }
        this.awayZoneShots.push(shot)
      }
    },
    drawRect (ctx, color, position, text, textPos, fontSize = '26px', lineWidth = 3) {
      ctx.beginPath()
      ctx.fillStyle = color
      ctx.strokeStyle = '#FFFFFF'
      ctx.lineWidth = lineWidth
      ctx.fillRect(position[0], position[1], position[2], position[3])
      ctx.strokeRect(position[0], position[1], position[2], position[3])
      ctx.closePath()
    },
    drawText (ctx, text, textPosition, textSize = '26px') {
      ctx.beginPath()
      ctx.font = textSize + ' sans-serif'
      ctx.fillStyle = 'rgba(0, 0, 0, 1)'
      ctx.fillText(text, textPosition[0], textPosition[1])
      ctx.closePath()
    },
    drawCustom (ctx, color, initPos, movePoints) {
      ctx.beginPath()
      ctx.fillStyle = color
      ctx.strokeStyle = 'white'
      ctx.moveTo(initPos[0], initPos[1])
      // Loop over move points
      for (var prop of movePoints) {
        ctx.lineTo(prop.x, prop.y)
      }
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
    },
    drawCircle (ctx, color, position, radius, lineWidth = 2) {
      ctx.beginPath()
      ctx.fillStyle = color
      ctx.strokeStyle = '#FFFFFF'
      ctx.lineWidth = lineWidth
      ctx.arc(position[0], position[1], radius, 0, 2 * Math.PI)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
    }
  },
  created: function () {
    // this.fetchShotTotals()
    this.updateRemotes()
    // this.period = this.$route.params.period
  },
  mounted: function () {
      this.fetchShotmap()
  }
}
</script>

<style lang="scss" scoped>
.team_logo{
  width: 100px;
  height:100px;
}
.tbl-name{
  width:10%;
}
.tbl-goal{
  background-color:rgba(202, 202, 202, 0.493); 
  color:black;
}
.tbl-shots{
  background-color:rgba(185, 190, 197, 0.493);
  color:black;
}
.large{
  font-size:1.5em;
}
.medium{
  font-size:1.2em;
}
.fo-left{
  background-color:rgba(173, 231, 220, 0.493);
  color:black;
}
.fo-center{
  background-color:rgba(158, 147, 157, 0.493);
  color:black;
}
.fo-right{
  background-color:rgba(68, 140, 148, 0.493);
  color:black;
}
.fo-total{
  background-color:rgba(230, 230, 169, 0.493);
  color:black;
}
.small {
  font-size: 1em;
  display: inline-block;
}
.table-responsive {
  display: block;
  width: 100%;
  min-height: 0.01%;
  overflow-x: auto;
}
.active p{
  font-size:84px;
}
.bold-el{
  font-size:26px;
  font-style: bold;
}
.select{
      font-size: 20px;
}
.is-success {
  font-size: 1.5em;
}
.is-danger {
  font-size: 1.5em;
}
.td p {
  font-size: 0.5em;

}
.table th {
    text-align: center;
}
.table td {
    text-align: center;
}
.player_icon {
  width: 162px;
  height: 162px;
  border-radius: 50%;
  vertical-align: middle;
}
.team_text {
  font-size: 1.5em;
  margin-left: 20px;
}
.player_info {
  font-size: 1.4em;
}
.score {
  font-size: 34px;
}

@media screen and (max-width: 600px){
     .is-canvas-responsive{
         display:none;
    }
}
 @media screen and (max-width: 800px){
     .is-responsive{
         width: 100%;
         border-collapse: collapse;
         border-spacing: 0;
         display: block;
         position: relative;
    }
     td:empty:before{
         content: '\00a0';
    }
     th, td{
         margin: 0;
         vertical-align: top;
    }
     th{
         text-align: left;
    }
     thead{
         border-right: solid 2px;
         display: block;
         float: left;
    }
     tr{
         display: block;
         padding: 0 10px 0 0;
    }
     th::before{
         content: "\00a0";
    }
     td, th{
         border-width: 0 0 1px;
    }
     tbody{
         display: block;
         width: auto;
         position: relative;
         overflow-x: auto;
         white-space: nowrap;
    }
     tr{
         display: inline-block;
         vertical-align: top;
    }
     th{
         display: block;
         text-align: right;
    }
     td{
         display: block;
         min-height: 1.25em;
         text-align: left;
    }
     th, td &:last-child{
         border-bottom-width: 0;
    }
     tr &:last-child td:not(:last-child){
         //border: $table-cell-border;
         // border-width: $table-cell-border-width;
    }
     &.is-bordered td, th{
         border-width: 1px;
    }
     tr td, th &:last-child{
         border-bottom-width: 1px;
    }
     &:last-child td, th{
         border-width: 1px;
    }
}
</style>



// WEBPACK FOOTER //
// match-stats-opposition.vue?7e029c98